import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import Swal from 'sweetalert2';
import { DocumentTemplateService as ComponentService } from './document-template.service';
import { AddDocumentTemplateComponent as AddComponent } from './add-document-template/add-document-template.component';
import { EditDocumentTemplateComponent as EditComponent } from './edit-document-template/edit-document-template.component';
import { helper } from 'src/environments/helper';

import { DocumentTemplateSignaturesComponent } from './document-template-signatures/document-template-signatures.component';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
    selector: 'app-document-template',
    templateUrl: './document-template.component.html',
    styleUrls: ['./document-template.component.scss'],
})
export class DocumentTemplateComponent
    implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;
    activeValue: string = '-1';
    publicValue: string = '-1';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = this.componentService.getListDTUrl;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    resetForm() {
        this.activeValue = '-1';
        this.publicValue = '-1';

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.rerenderDT(true);
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }
    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private componentService: ComponentService,
        public permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            responsive: true,
            searching: false,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.active = this.activeValue;
                dataTablesParameters.public = this.publicValue;
                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Draft',
                    data: null,
                    width: '400px',
                    render: (data: any, type: any, row: any) => {
                        return `<strong>Draft:</strong> ${row.name} <br> <strong>Tip Cerere:</strong> ${row.type}

                        `
                    }
                },
                // {
                //     title: 'Denumire',
                //     data: 'name',
                //     width: '300px',
                // },
                {
                    title: 'Registru',
                    data: 'registry_name',
                },
                {
                    title: 'Drafturi Diferite?',
                    data: 'document_generabil_dual',
                    render: (data: any, type: any, row: any) => {
                        return row.document_generabil_dual === true
                            ? 'Da'
                            : 'Nu';
                    }
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (row : any) => {
                        return `
                        <div class="d-flex align-center justify-content-left">
							<button class="action-btn signatures ms-1">
                				<img class="btn-img" src="../../../../assets/icons/simple-signature-contract.svg" alt="signatures"/>
              				</button>
              				<button class="action-btn edit ms-1">
                				<img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
              				</button>
              				<button class="action-btn delete ms-1">
                				<img class="btn-img" src="../../../../assets/icons/delete.svg" alt="delete"/>
              				</button>
                            <button type="button" class="action-btn update_status_active ms-1 ` +
                                (row.active == true ? 'action-success' : 'action-danger') +
                                `">
                                    <img class="btn-img" src="` +
                                (row.active == true
                                    ? '/assets/icons/check-white.svg'
                                    : '/assets/icons/close-white.svg') +
                                `" alt="update_status_active"/>
                            </button>
                        </div>
            `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const signaturesIcon = lastTd?.querySelector(
                    '.signatures'
                ) as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;
                const updateStatusActiveIcon = lastTd ?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;

                if (signaturesIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'urbanism-module.settings.template-documente.actualizare-semnatari'
                        )
                    ) {
                        signaturesIcon.style.display = 'none';
                    }
                    signaturesIcon.addEventListener('click', () => {
                        this.openSignaturesDialog(data);
                    });
                }

                if (editIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'urbanism-module.settings.template-documente.update'
                        )
                    ) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (
                        !this.permissionsService.hasPermission(
                            'urbanism-module.settings.template-documente.delete'
                        )
                    ) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.delete(id);
                    });
                }

                if (updateStatusActiveIcon) {
                    // if (
                    //     !this.permissionsService.hasPermission(
                    //         'urbanism-module.settings.template-documente.update-status'
                    //     )
                    // ) {
                    //     updateStatusActiveIcon.style.display = 'none';
                    // }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddComponent, {
            height: '80vh',
            width: '70vw',
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare adaugată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: any) {
        const dialogRef = this.dialog.open(EditComponent, {
            height: '80vh',
            width: '70vw',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openSignaturesDialog(data: any) {
        const dialogRef = this.dialog.open(DocumentTemplateSignaturesComponent, {
            height: '70vh',
            maxHeight: '70vh',
            width: '75vh',
            maxWidth: '75vh',
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Înregistrare actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    delete(id: number) {
        Swal.fire({
            title: 'Sunteți sigur?',
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Confirm!',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
        }).then((result) => {
            if (result.isConfirmed) {
                this.componentService.delete(id).subscribe(() => {
                    this.rerenderDT();
                    Swal.fire({
                        title: 'Șters!',
                        text: 'Înregistrare ștersă cu succes.',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    });
                });
            }
        });
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul template-ului selectat!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        console.log(id);
        this.componentService.changeStatuseActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Functie actualizată cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err : any) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }
}
